export default "__VITE_ASSET__CwWSX8XS__"